import { createReducer, on } from "@ngrx/store"
import { IFinantialReport } from "src/app/shared/interfaces/finantial-report/ifinantial-report"
import { finantialReportActions } from "./finantial-report.actions"


export interface IFinantialReportState {
    finantial_report: IFinantialReport
}

const initialState: IFinantialReportState = {
    finantial_report: {
        economia_mes_a_mes: [
            {
              label: "03/23",
              data: 5000
            },
            {
              label: "04/23",
              data: 2000
            },
            {
              label: "05/23",
              data: 2200
            },
            {
              label: "06/23",
              data: 2800
            },
            {
              label: "07/23",
              data: 2950
            },
            {
              label: "08/23",
              data: 3800
            },
            {
              label: "09/23",
              data: 4600
            },
            {
              label: "10/23",
              data: 2200
            },
            {
              label: "11/23",
              data: 2800
            },
            {
              label: "12/23",
              data: 2950
            },
            {
              label: "01/24",
              data: 3800
            },
            {
              label: "02/24",
              data: 4600
            }
        ],
        atendimento_mes_a_mes: [
            {
              label: "03/23",
              data: 25
            },
            {
              label: "04/23",
              data: 20
            },
            {
              label: "05/23",
              data: 30
            },
            {
              label: "06/23",
              data: 40
            },
            {
              label: "07/23",
              data: 50
            },
            {
              label: "08/23",
              data: 50
            },
            {
              label: "09/23",
              data: 48
            },
            {
              label: "10/23",
              data: 30
            },
            {
              label: "11/23",
              data: 40
            },
            {
              label: "12/23",
              data: 50
            },
            {
              label: "01/24",
              data: 50
            },
            {
              label: "02/24",
              data: 48
            }
        ],
        lucro_mes_a_mes: [
          {
            label: "03/23",
            data: 5000
          },
          {
            label: "04/23",
            data: 2000
          },
          {
            label: "05/23",
            data: 2200
          },
          {
            label: "06/23",
            data: 2800
          },
          {
            label: "07/23",
            data: 2950
          },
          {
            label: "08/23",
            data: 3800
          },
          {
            label: "09/23",
            data: 4600
          },
          {
            label: "10/23",
            data: 2200
          },
          {
            label: "11/23",
            data: 2800
          },
          {
            label: "12/23",
            data: 2950
          },
          {
            label: "01/24",
            data: 3800
          },
          {
            label: "02/24",
            data: 4600
          }
      ],
      despesa_mes_a_mes: [
        {
          label: "03/23",
          data: 2000
        },
        {
          label: "04/23",
          data: 1750
        },
        {
          label: "05/23",
          data: 1000
        },
        {
          label: "06/23",
          data: 1200
        },
        {
          label: "07/23",
          data: 1250
        },
        {
          label: "08/23",
          data: 1500
        },
        {
          label: "09/23",
          data: 2258
        },
        {
          label: "09/23",
          data: 4600
        },
        {
          label: "10/23",
          data: 2200
        },
        {
          label: "11/23",
          data: 2800
        },
        {
          label: "12/23",
          data: 2950
        },
        {
          label: "01/24",
          data: 3800
        },
        {
          label: "02/24",
          data: 4600
        }
      ]
    }
}

export const finantialReportReducer = createReducer(
    initialState,
    on(
        finantialReportActions.loadFinantialReportSuccess,
        (state, { finantial_report }) => ({
            ...state,
            finantial_report: finantial_report
        })
    )
)